export class NgDataTableSortFormatterUtility {
  resolveObjectValue(path, obj) {
    return path.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : null
    }, obj || self)
  }
}
